import EventEmitter from 'events'
import axios from 'axios'
import User from '@/js/user.js'
import Constant from '@/js/constant.js'

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const loginEvent = 'loginEvent'
const HOST = Constant.hosts.url
const LOGIN_URL = 'oauth/token'

const instance = axios.create({
  baseURL: HOST,
  timeout: 100000,
  headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
})

class AuthService extends EventEmitter {
    idToken = null;
    profile = null;
    tokenExpiry = null;

    // Send a request to the login URL and save the returned
    login (context, creds) {
      localStorage.removeItem('logoutReason')
      context.error = ''
      const data = creds
      data['grant_type'] = 'password'
      data['client_id'] = 'web_client'
      data['client_secret'] = 'onMszOkl9Xh6JiXEyJu1YmQKveCSbuNVoVIRzOWEf3Ll2BYULmmKhVmZ1R3t'
      data['redirect_uri'] = 'http://snappms.co'
      const rawData = []
      for (const key in data) {
        rawData.push(`${key}=${data[key]}`)
      }
      const body = rawData.join('&')
      instance.post(LOGIN_URL, body).then(function (response) {
        localStorage.setItem('logged_email', creds.username)
        User.getProfile(context, response)
      })
        .catch(function () {
          context.isLoading = false
          context.$vs.loading.close()
          context.$vs.dialog({
            type: 'alert',
            color: 'danger',
            title: 'Login',
            text: 'Invalid login details',
            accept: null
          })
        })
    }

    logOut () {
      localStorage.removeItem('access_token')
      localStorage.removeItem('userInfo')
      this.emit(loginEvent, { loggedIn: false })
    }

    isAuthenticated () {
      if (localStorage.getItem('access_token') !== null) {
        return localStorage.getItem('access_token')
      } else {
        return false
      }
    }
}
export default new AuthService()
